import React from "react";
import { FiChevronUp, FiChevronDown, FiHome } from "react-icons/fi";
import {
  PROPERTY_TYPES,
  PROPERTY_TYPE_LABELS,
} from "../../../constants/aiPriceData";
import AccordionSection from "./AccordionSection";

const PropertyTypeSelector = ({
  selectedPropertyType,
  isOpen,
  onToggle,
  onChange,
  dropdownRef,
  isExpanded,
  onToggleSection,
  transitionStyle,
  config = null, // Allow custom config to be passed
  propertyTypes = null, // Allow custom property types to be passed
  title = "Chọn loại bất động sản", // Default title
  placeholder = "Chọn loại bất động sản", // Default placeholder
}) => {
  // Use custom propertyTypes if provided, otherwise use config or default
  const availablePropertyTypes = propertyTypes
    ? Object.values(propertyTypes)
    : config
    ? Object.keys(config)
    : Object.values(PROPERTY_TYPES);

  // Create correct mapping for property type labels
  const propertyTypeLabels = propertyTypes
    ? Object.keys(propertyTypes).reduce((acc, key) => {
        acc[propertyTypes[key]] = propertyTypes[key]; // Map value to value
        return acc;
      }, {})
    : config
    ? Object.keys(config).reduce((acc, key) => {
        acc[key] = key;
        return acc;
      }, {})
    : PROPERTY_TYPE_LABELS;
  return (
    <div className={isOpen ? "relative z-50 overflow-visible" : ""}>
      <AccordionSection
        title={title}
        isExpanded={isExpanded}
        toggleExpand={onToggleSection}
        icon={<FiHome className="text-blue-600" />}
        transitionStyle={transitionStyle}
      >
        <div className="mb-3 sm:mb-4">
          <label className="block text-gray-700 font-medium mb-2 text-sm sm:text-base">
            Loại Bất động sản
            <span className="text-red-500 ml-1">*</span>
          </label>
          <div className="relative overflow-visible" ref={dropdownRef}>
            <button
              type="button"
              className={`w-full p-3 sm:p-4 text-left bg-white border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 min-h-[48px] touch-manipulation text-sm sm:text-base ${
                selectedPropertyType ? "text-gray-900" : "text-gray-500"
              } ${
                isOpen
                  ? "border-blue-500 ring-2 ring-blue-500"
                  : "border-gray-300 hover:border-gray-400"
              }`}
              style={{
                backgroundColor: "white",
                color: selectedPropertyType ? "#111827" : "#6b7280", // gray-900 : gray-500
              }}
              onClick={(e) => onToggle("propertyType", e)}
            >
              <span
                className="block truncate"
                style={{
                  color: "inherit",
                  fontSize: "inherit",
                }}
              >
                {selectedPropertyType
                  ? propertyTypeLabels[selectedPropertyType] ||
                    selectedPropertyType
                  : placeholder}
              </span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                {isOpen ? (
                  <FiChevronUp className="h-5 w-5 sm:h-4 sm:w-4 text-gray-400" />
                ) : (
                  <FiChevronDown className="h-5 w-5 sm:h-4 sm:w-4 text-gray-400" />
                )}
              </span>
            </button>

            {isOpen && (
              <div
                className="absolute z-50 mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-xl max-h-64 sm:max-h-60 overflow-auto"
                style={{
                  top: "100%",
                  left: 0,
                  right: 0,
                  backgroundColor: "white",
                  color: "#111827", // gray-900
                }}
              >
                {availablePropertyTypes.map((type) => (
                  <div
                    key={type}
                    className={`cursor-pointer select-none relative py-3 sm:py-2 pl-4 sm:pl-3 pr-10 sm:pr-9 hover:bg-blue-50 active:bg-blue-100 transition-colors duration-150 text-sm sm:text-base min-h-[48px] sm:min-h-auto flex items-center touch-manipulation ${
                      selectedPropertyType === type
                        ? "bg-blue-100 text-blue-900 font-medium"
                        : "text-gray-900 hover:text-gray-700"
                    }`}
                    style={{
                      color:
                        selectedPropertyType === type ? "#1e3a8a" : "#111827", // blue-900 : gray-900
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onChange(type);
                    }}
                  >
                    <span
                      className="block truncate"
                      style={{
                        color: "inherit",
                        fontSize: "inherit",
                      }}
                    >
                      {propertyTypeLabels[type] || type}
                    </span>
                    {selectedPropertyType === type && (
                      <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600 font-semibold">
                        ✓
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </AccordionSection>
    </div>
  );
};

export default PropertyTypeSelector;
